// takes the id of an audio tag html element which has an attached src and returns the duration (secs) of the attached audio file.
window.getAudioDurationFromAudioElement = (audioElement) => {
    return new Promise((resolve, reject) => {
        if (audioElement.readyState >= 1) {
            resolve(audioElement.duration);
        } else {
            audioElement.onloadedmetadata = () => {
                resolve(audioElement.duration);
            };
            audioElement.onerror = () => {
                reject("Could not load audio metadata");
            };
        }
    });
};

window.drawAudioWaveform = async function (src, canvas, fillColor="#3587FF") {
    const ctx = canvas.getContext("2d");

    // Handle HiDPI displays for crisp drawing
    const dpr = window.devicePixelRatio || 1;
    canvas.width = canvas.clientWidth * dpr;
    canvas.height = canvas.clientHeight * dpr;
    ctx.scale(dpr, dpr);

    const response = await fetch(src);
    const arrayBuffer = await response.arrayBuffer();
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

    const rawData = audioBuffer.getChannelData(0); // mono channel
    const canvasWidth = canvas.clientWidth;   // Use clientWidth for drawing coords
    const canvasHeight = canvas.clientHeight;

    const gap = 1; 
    const emptyBarHeight= 0.02 // if there is no audio content at this part, draw a bar 2% of the canvas height.
    const samples = Math.floor(canvasWidth / (1 + gap)); // max bars fitting canvas width
    const blockSize = Math.floor(rawData.length / samples);
    const amplitudes = [];

    for (let i = 0; i < samples; i++) {
        let sum = 0;
        for (let j = 0; j < blockSize; j++) {
            sum += Math.abs(rawData[i * blockSize + j]);
        }
        amplitudes.push(Math.max(sum / blockSize, emptyBarHeight)); 
    }

    const maxAmplitude = Math.max(...amplitudes);
    let normalisedAmplitudes
    if (maxAmplitude !== 0) {
        normalisedAmplitudes = amplitudes.map(a => {
            if(a === emptyBarHeight){
                return a
            } else {
                return a / maxAmplitude
            }
        });
    } else {
        normalisedAmplitudes = amplitudes
    }
    

    const totalGaps = (samples - 1) * gap;
    const barWidth = (canvasWidth - totalGaps) / samples; // exact fractional width

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    ctx.fillStyle = fillColor;

    normalisedAmplitudes.forEach((amp, i) => {
        const x = i * (barWidth + gap);
        const y = amp * canvasHeight;
        ctx.fillRect(x, (canvasHeight - y) / 2, barWidth, y);
    });
}